import React from "react";
import HomeHero from "../container/homeHero/HomeHero";
import HomeAbout from "../container/homeAbout/HomeAbout";
import HomeWork from "../container/homeWork/HomeWork";
import HomeDesign from "../container/homeDesign/HomeDesign";
import HomeExpect from "../container/homeExpect/HomeExpect";
import HomeOffer from "../container/homeOffer/HomeOffer";
import HomeFAQ from "../container/homeFAQ/HomeFAQ";
import HomeForm from "../container/homeForm/HomeForm";
import { Helmet } from "react-helmet-async";
// import Popup from "../components/Popup/Popup";

const Home = () => {
  // const [showPopup, setShowPopup] = useState(true);

  // const handleClosePopup = () => {
  //   setShowPopup(false);
  // };
  return (
    <>
      <Helmet>
        <title>Radiksez</title>

        <meta
          name="description"
          content="Radiksez® is a strategic outsourcing agency leading the world’s most visionary companies to business big ideas and leap to what’s next."
        />
        <link rel="canonical" href="https://radiksez.com/" />
      </Helmet>
      <HomeHero />
      <HomeAbout />
      <HomeOffer />
      <HomeWork />
      <HomeDesign />
      <HomeExpect />
      <HomeFAQ />
      <HomeForm />
    </>
  );
};

export default Home;
